import $ from 'jquery';
import { select } from 'd3-selection';
import { scaleOrdinal } from 'd3-scale';
import { pie, arc } from 'd3-shape';
import { entries } from 'd3-collection';

function generateView(value, container, notFullColor, fullColor) {
  let svg = select(container).append('svg');
  const width = container.getBoundingClientRect().width;
  const height = container.getBoundingClientRect().height;
  const radius = Math.min(width, height) / 2;
  const intValue = parseInt(value, 10);

  svg = svg
    .attr('width', width)
    .attr('height', height)
    .append('g')
    .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');

  // Create dummy data
  const data = { a: intValue, b: 100 - intValue };

  // set the color scale
  const completionColor = intValue !== 100 ? notFullColor : fullColor;
  const color = scaleOrdinal()
    .domain(data)
    .range([completionColor, 'transparent']);

  const pieChart = pie()
    .value(d => d.value)
    .sort(null);

  const data_ready = pieChart(entries(data));

  svg
    .selectAll()
    .data(data_ready)
    .enter()
    .append('path')
    .attr(
      'd',
      arc()
        .innerRadius(0)
        .outerRadius(radius)
    )
    .attr('fill', d => color(d.data.key));
}

export default {
  render: function(data, container, notFullColor, fullColor) {
    $(container).empty();
    $(container).each((i, el) => generateView(data, el, notFullColor, fullColor));
  }
};
